// Admin utility functions
const ADMIN_EMAIL_DOMAINS = ['@t-bit.io'];

export const isAdmin = (email: string): boolean => {
  return ADMIN_EMAIL_DOMAINS.some((domain) => email.includes(domain));
};
